// import React, { useEffect, useState } from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   LabelList, 
//   ResponsiveContainer,
// } from "recharts";
// import { Box, Typography, CircularProgress, Paper, } from "@mui/material";
// import { useDashboardService } from "../../services/dashboardService";
// import dayjs from "dayjs";

// const CheckInBarChartLatestDate = ({ selectedDate }) => {
//   const { fetchBVWisrCheckInStats } = useDashboardService();
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     let timeoutId;

//     const loadData = async () => {
//       setLoading(true);
//       try {
//         const response = await fetchBVWisrCheckInStats({asOnDate: selectedDate}, false);
//         if (!Array.isArray(response)) return;

//         // Find the latest CheckInDate
//         const latestDate = response.reduce((latest, curr) => {
//           return dayjs(curr.CheckInDate).isAfter(latest)
//             ? dayjs(curr.CheckInDate)
//             : latest;
//         }, dayjs(response[0].CheckInDate));

//         // Filter records for the latest date
//         const latestRecords = response.filter(item =>
//           dayjs(item.CheckInDate).isSame(latestDate, "day")
//         );

//         const formatted = latestRecords.map(item => {
//           const percentage =
//             item.TotalEmployee > 0
//               ? ((item.TotalCheckIns / item.TotalEmployee) * 100).toFixed(1)
//               : 0;
//           return {
//             name: item.Business_Vertical_Desc || "Unknown",
//             percentage: parseFloat(percentage),
//           };
//         });

//         setChartData(formatted.sort((a, b) => b.percentage - a.percentage));
//       } catch (err) {
//         console.error("Failed to fetch check-in stats:", err);
//       }
//       setLoading(false);
//     };

//     if (selectedDate) {
//          setLoading(true);
//       timeoutId = setTimeout(() => {
//         loadData();
//       }, 300); // delay 3 seconds
//     }

//     return () => clearTimeout(timeoutId); // cleanup if component unmounts or asOnDate changes
//   }, [selectedDate]);

//   return (
//      <Box elevation={2}  
//       sx={{ 
//         borderRadius: 2,
//         p: 1, height: 305,
//         boxShadow: 1,
//         bgcolor: "background.paper", 
//         alignItems: "center", 
//       }}
//      > 
   
//       <Typography variant="h6" sx={{ mb: 1 }}>
//         Check-In % by Vertical ({dayjs(selectedDate).format("MMM-DD")})
//       </Typography>
//       {loading ? (
//         <Box
//           height={240}
//           display="flex"
//           alignItems="center"
//           justifyContent="center"
//         >
//           <CircularProgress size={34} />
//         </Box>
//       ) : (
//         <ResponsiveContainer width="100%" height="85%">
//           <BarChart
//             layout="vertical"
//             data={chartData}
//             margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
//             barCategoryGap="10%"
//           >
//             <XAxis type="number" domain={[0, 100]} hide />
//             <YAxis
//               type="category"
//               dataKey="name"
//               width={180}
//               tick={{ fontSize: 12 }}
//             />
//             <Tooltip formatter={val => `${val}%`} />
//             <Bar
//               dataKey="percentage"
//               fill="#1976d2"
//               barSize={12}
//               radius={[0, 0, 0, 0]}
//             >
//               <LabelList
//                 dataKey="percentage"
//                 position="right"
//                 formatter={val => `${val}%`}
//               />
//             </Bar>
//           </BarChart>
//         </ResponsiveContainer>
//       )}
   
//      </Box>
//   );
// };

// export default CheckInBarChartLatestDate;

import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useDashboardService } from "../../services/dashboardService";
import dayjs from "dayjs";

const CheckInBarChartLatestDate = ({ selectedDate }) => {
  const { fetchBVWisrCheckInStats } = useDashboardService();
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let timeoutId;

    const loadData = async () => {
      setLoading(true);
      try {
        const response = await fetchBVWisrCheckInStats({ asOnDate: selectedDate }, false);
        if (!Array.isArray(response)) return;

        const formatted = response.map(item => {
          const percentage =
            item.TotalEmployee > 0
              ? ((item.TotalCheckIns / item.TotalEmployee) * 100).toFixed(1)
              : 0;
          return {
            name: item.Business_Vertical_Desc || "Unknown",
            percentage: parseFloat(percentage),
          };
        });

        setChartData(formatted.sort((a, b) => b.percentage - a.percentage));
      } catch (err) {
        console.error("Failed to fetch check-in stats:", err);
      }
      setLoading(false);
    };

    if (selectedDate) {
      setLoading(true);
      timeoutId = setTimeout(loadData, 300); // optional debounce
    }

    return () => clearTimeout(timeoutId);
  }, [selectedDate]);

  return (
    <Box
      sx={{
        borderRadius: 2,
        p: 1,
        height: 305,
        boxShadow: 1,
        bgcolor: "background.paper",
        alignItems: "center",
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        Check-In % by Vertical ({dayjs(selectedDate).format("MMM-DD")})
      </Typography>

      {loading ? (
        <Box height={240} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress size={34} />
        </Box>
      ) : (
        <ResponsiveContainer width="100%" height="85%">
          <BarChart
            layout="vertical"
            data={chartData}
            margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
            barCategoryGap="10%"
          >
            <XAxis type="number" domain={[0, 100]} hide />
            <YAxis
              type="category"
              dataKey="name"
              width={180}
              tick={{ fontSize: 12 }}
            />
            <Tooltip formatter={val => `${val}%`} />
            <Bar dataKey="percentage" fill="#1976d2" barSize={12}>
              <LabelList dataKey="percentage" position="right" formatter={val => `${val}%`} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};

export default CheckInBarChartLatestDate;
